<template>
  <form @submit.prevent="submitForm()">
    <div class="page-wrap p-3">
      <div class="mt-3 mb-3">
        <a :href="`/students`">
          <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
          Назад
        </a>
      </div>

      <div class="page-header p-3 mb-3 mt-3">
        <h3>Редактирование данных обучающегося</h3>
      </div>
    </div>
    <div class="page-content mt-3 mb-3">
      <div class="card">
        <div class="card-header">
          <h6>Личные данные</h6>
        </div>
        <div class="card-body">
          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="iin" class="form-label col-md-3">
                  ИИН
                </label>
                <div class="col-md-9">
                  <input class="form-control" id="iin" type="text"
                         :minlength="12" :maxlength="12"
                         v-model="student.iin"
                         :disabled="isDisabled()"
                         required>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="lastname" class="form-label col-md-3">
                  Фамилия
                </label>
                <div class="col-md-9">
                  <input class="form-control" id="lastname" type="text"
                         v-model="student.lastname"
                         :disabled="isDisabled()"
                         required>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="firstname" class="form-label col-md-3">
                  Имя
                </label>
                <div class="col-md-9">
                  <input class="form-control" id="firstname" type="text"
                         v-model="student.firstname"
                         :disabled="isDisabled()"
                         required>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="patronymic" class="form-label col-md-3">
                  Отчество
                </label>
                <div class="col-md-9">
                  <input class="form-control" id="patronymic" type="text"
                         v-model="student.patronymic"
                         :disabled="isDisabled()">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h6>Дополнительная информация</h6>
        </div>
        <div class="card-body">
          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="university" class="form-label col-md-3">
                  ВУЗ
                </label>
                <div class="col-md-9">
                  <select v-model="student.universityId" id="university"
                          class="form-select"
                          :disabled="isDisabled()"
                          required>
                    <option v-for="university in universities" :key="university.universityId"
                            :value="university.universityId">
                      {{ university.nameRu }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="degree" class="form-label col-md-3">
                  Академическая степень
                </label>
                <div class="col-md-9">
                  <select v-model="student.degreeId" class="form-select" id="degree"
                          :disabled="isDisabled()"
                          required>
                    <option v-for="degree in degrees" :key="degree.id"
                            :value="degree.id">
                      {{ degree.nameRu }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="profession" class="form-label col-md-3">
                  Специальность
                </label>
                <div class="col-md-9">
                  <select v-model="student.professionCode" class="form-select" id="profession"
                          v-on:change="onChangeProfession"
                          :disabled="isDisabled()"
                          required>
                    <option :value="null">-- не предусмотрено --</option>
                    <option v-for="profession in professions" :key="profession.code"
                            :value="profession.code"
                            :data-name-ru="profession.nameRu">
                      {{ profession.code }} {{ profession.nameRu }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="paymentForm" class="form-label col-md-3">
                  Форма оплаты
                </label>
                <div class="col-md-9">
                  <select v-model="student.paymentFormId" class="form-select" id="paymentForm"
                          :disabled="isDisabled()"
                          required>
                    <option v-for="paymentForm in paymentForms" :key="paymentForm.id" :value="paymentForm.id">
                      {{ paymentForm.nameRu }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="creditAmountPerProgram" class="form-label col-md-3">
                  Стипендиальная программа
                </label>
                <div class="col-md-9">
                  <select v-model="student.creditAmountPerProgram" class="form-select" id="creditAmountPerProgram"
                          :disabled="isDisabled()"
                          required>
                    <option v-for="scholarshipProgram in scholarshipPrograms" :key="scholarshipProgram.id"
                            :value="scholarshipProgram.id">
                      {{ scholarshipProgram.nameRu }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="differentiatedGrant" class="form-label col-md-3">
                  Дифференцированный грант
                </label>
                <div class="col-md-9">
                  <select v-model="student.differentiatedGrant" class="form-select" id="differentiatedGrant"
                          :disabled="isDisabled()"
                          required>
                    <option v-for="option in yesNoList" :key="option.id"
                            :value="option.id">
                      {{ option.nameRu }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="course" class="form-label col-md-3">
                  Курс
                </label>
                <div class="col-md-9">
                  <select v-model="student.course" class="form-select" id="course"
                          :disabled="isDisabled2University()"
                  >
                    <option v-for="option in courseList" :key="option.id"
                            :value="option.id">
                      {{ option.id }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="isFirstCourse" class="form-label col-md-3">
                  1 курс (новый прием)
                </label>
                <div class="col-md-9">
                  <select v-model="student.isFirstCourse" class="form-select" id="isFirstCourse"
                          :disabled="isDisabled2University()"
                  >
                    <option v-for="option in yesNoList" :key="option.id"
                            :value="option.id">
                      {{ option.nameRu }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="admissionYear" class="form-label col-md-3">
                  Год поступления
                </label>
                <div class="col-md-9">
                  <select v-model="student.admissionYear" class="form-select" id="admissionYear"
                          :disabled="isDisabled2University()"
                  >
                    <option v-for="option in yearList" :key="option.id"
                            :value="option.id">
                      {{ option.id }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="transferredFromRegionalToNationalHEI" class="form-label col-md-3">
                  Перевод с регионального ОВПО в национальный ОВПО
                </label>
                <div class="col-md-9">
                  <select v-model="student.transferredFromRegionalToNationalHEI" class="form-select" id="transferredFromRegionalToNationalHEI"
                          :disabled="isDisabled()"
                          required>
                    <option v-for="option in yesNoList" :key="option.id"
                            :value="option.id">
                      {{ option.nameRu }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="deducted" class="form-label col-md-3">
                  Отчислен
                </label>
                <div class="col-md-9">
                  <select v-model="student.deducted" class="form-select" id="deducted"
                          :disabled="isDisabled2University()"
                          required>
                    <option v-for="option in yesNoList" :key="option.id"
                            :value="option.id">
                      {{ option.nameRu }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>


          <div class="col-md-12" v-if="student.deducted">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="deductOrderMoveDate" class="form-label col-md-3">
                  Дата отчисления
                </label>
                <div class="col-md-9">
                  <input
                      id="deductOrderMoveDate"
                      type="date"
                      v-model="student.deductOrderMoveDate"
                      :disabled="isDisabled2University()"
                      class="form-control"
                      required
                  />
                </div>
              </div>
            </div>
          </div>


          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="academicLeave" class="form-label col-md-3">
                  Академический отпуск
                </label>
                <div class="col-md-9">
                  <select v-model="student.academicLeave" class="form-select" id="academicLeave"
                          :disabled="isDisabled2University()">
                    <option v-for="option in yesNoList" :key="option.id"
                            :value="option.id">
                      {{ option.nameRu }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12" v-if="student.academicLeave">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="academicLeaveOrderNumber" class="form-label col-md-3">
                  Номер приказа академического отпуска
                </label>
                <div class="col-md-9">
                  <input
                      id="academicLeaveOrderNumber"
                      v-model="student.academicLeaveOrderNumber"
                      :disabled="isDisabled2University()"
                      class="form-control"
                      required
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12" v-if="student.academicLeave">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="academicLeaveOrderDate" class="form-label col-md-3">
                  Дата приказа академического отпуска
                </label>
                <div class="col-md-9">
                  <input
                      id="academicLeaveOrderDate"
                      type="date"
                      v-model="student.academicLeaveOrderDate"
                      :disabled="isDisabled2University()"
                      class="form-control"
                      required
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12" v-if="student.academicLeave">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="academicLeaveOrderStartDate" class="form-label col-md-3">
                  Дата начало академического отпуска
                </label>
                <div class="col-md-9">
                  <input
                      id="academicLeaveOrderStartDate"
                      type="date"
                      v-model="student.academicLeaveOrderStartDate"
                      :disabled="isDisabled2University()"
                      class="form-control"
                      required
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12" v-if="student.academicLeave">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="academicLeaveOrderFinishDate" class="form-label col-md-3">
                  Дата окончание академического отпуска
                </label>
                <div class="col-md-9">
                  <input
                      id="academicLeaveOrderFinishDate"
                      type="date"
                      v-model="student.academicLeaveOrderFinishDate"
                      :disabled="isDisabled2University()"
                      class="form-control"
                      required
                  />
                </div>
              </div>
            </div>
          </div>


          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="transferToOtherUniversity" class="form-label col-md-3">
                  Перевод в другой ВУЗ
                </label>
                <div class="col-md-9">
                  <select v-model="student.transferToOtherUniversity" class="form-select" id="transferToOtherUniversity"
                          :disabled="isDisabled2University()">
                    <option v-for="option in yesNoList" :key="option.id"
                            :value="option.id">
                      {{ option.nameRu }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="transferredFromUniversity" class="form-label col-md-3">
                  Переведен из ВУЗа
                </label>
                <div class="col-md-9">
                  <select v-model="student.transferredFromUniversity" class="form-select" id="transferredFromUniversity"
                          :disabled="isDisabled2University()">
                    <option v-for="option in yesNoList" :key="option.id"
                            :value="option.id">
                      {{ option.nameRu }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12" v-if="student.transferToOtherUniversity || student.transferredFromUniversity">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="dateOfTransfer" class="form-label col-md-3">
                  Дата перевода
                </label>
                <div class="col-md-9">
                  <input
                      id="dateOfTransfer"
                      type="date"
                      v-model="student.dateOfTransfer"
                      :disabled="isDisabled2University()"
                      class="form-control"
                      required
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label for="graduationCourse" class="form-label col-md-3">
                  Выпускной курс
                </label>
                <div class="col-md-9">
                  <select v-model="student.graduationCourse" class="form-select" id="graduationCourse"
                          :disabled="isDisabled2University()"
                          required>
                    <option v-for="option in yesNoList2" :key="option.id"
                            :value="option.id">
                      {{ option.nameRu }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="page-footer justify-content-end">
      <b-button variant="success" type="submit" v-if="hasEditPermission2University()">
        Сохранить
      </b-button>
    </div>
  </form>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import studentService from "@/services/studentService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import scholarshipProgramService from "@/services/scholarshipProgramService";
import universityService from "@/services/universityService";
import degreeService from "@/services/degreeService";
import professionService from "@/services/professionService";
import paymentFormService from "@/services/paymentFormService";

export default {
  components: {
    VueLoading
  },
  computed: {
    studentId() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      student: {
        uuid: null,
        trancheYear: null,
        trancheNumber: null,
        universityId: null,
        studentId: null,
        iin: null,
        lastname: null,
        firstname: null,
        patronymic: null,
        creditAmountPerProgram: null,
        deducted: null,
        deductOrderMoveDate: null,
        differentiatedGrant: null,
        transferredFromRegionalToNationalHEI: null,
        professionCode: null,
        professionName: null,
        academicLeave: null,
        academicLeaveOrderNumber: null,
        academicLeaveOrderDate: null,
        academicLeaveOrderStartDate: null,
        academicLeaveOrderFinishDate: null,
        transferToOtherUniversity: null,
        transferredFromUniversity: null,
        dateOfTransfer: null,
        graduationCourse: null,
        course: null,
        isFirstCourse: null,
        admissionYear: null,
      },
      universities: [],
      degrees: [],
      professions: [],
      paymentForms: [],
      scholarshipPrograms: [],
      yesNoList: [
        {id: true, nameRu: "Да"},
        {id: false, nameRu: "Нет"},
      ],
      yesNoList2: [
        {id: 1, nameRu: "Да"},
        {id: 0, nameRu: "Нет"},
      ],
      courseList: [
        {id: 1},
        {id: 2},
        {id: 3},
        {id: 4},
        {id: 5},
        {id: 6},
        {id: 7},
        {id: 8},
      ],
      yearList: [],
    };
  },
  methods: {
    init() {
      this.initScholarshipPrograms();

      this.findById(this.studentId);

      for (var i = 2017; i <= new Date().getFullYear(); i++) {
        this.yearList.push({id: i});
      }
    },
    async findById(studentId) {
      this.isLoading = true;
      this.student = await studentService.findById(studentId);
      if (!this.student.professionCode) {
        this.student.professionCode = null;
      }
      this.isLoading = false;
    },
    async submitForm() {
      if (!this.hasEditPermission2University()) {
        return;
      }

      try {
        this.isLoading = true;

        this.student = await studentService.save(this.student);
        if (!this.student.professionCode) {
          this.student.professionCode = null;
        }

        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    onChangeProfession(event) {
      const selectedOption = event.target.selectedOptions[0];
      this.student.professionName = selectedOption.getAttribute('data-name-ru');
    },
    initUniversities() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      universityService.getAll(params)
          .then(response => {
            this.universities = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    initDegrees() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };

      degreeService.getAll(params)
          .then(response => {
            this.degrees = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    initProfessions() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };

      professionService.getAll(params)
          .then(response => {
            this.professions = response.list.sort((a, b) => a.code.localeCompare(b.code));
          });
    },
    initScholarshipPrograms() {
      scholarshipProgramService.getAll()
          .then(response => {
            this.scholarshipPrograms = response.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    initPaymentForms() {
      paymentFormService.getAll()
          .then(response => {
            this.paymentForms = response.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    isDisabled() {
      return this.hasEditPermission() === false;
    },

    isDisabled2University() {
      return this.hasEditPermission2University() === false;
    },

    hasEditPermission() {
      return this.isAdmin() ;
    },

    hasEditPermission2University() {
      return this.isAdmin() || this.isUniversityManager();
    },

    isAdmin() {
      return delegationService.isAdmin();
    },

    isUniversityManager() {
      return delegationService.isUniversityManager();
    }
  },
  mounted() {
    this.initUniversities();
    this.initDegrees();
    this.initProfessions();
    this.initScholarshipPrograms();
    this.initPaymentForms();

    this.init();
  }
};
</script>

<style scoped>
.p-3 {
  padding: 0.1rem !important;
}

.row {
  padding-top: 5px;
}

.card {
  margin-bottom: 15px;
}

</style>
